import $i from '~/i18n'
import * as actions from './actions'
import * as mutations from './mutations'

export default{
  namespaced:true,
  state: () => ({
    lastCourse: [],
    filterList: [],
    courseDetail: {},
    goals: [],
    msgs: [],
    listCourse: [],
    someCatsListCourse: [],
    instractor: [],
    counts:null,
  }),
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/courses/index.js